const DEFAULT_COURSE_COUNT = 0;

const DEFAULT_AVGS_FILTER = 0;

const DEFAULT_PAGE = 1;

const DEFAULT_LIMIT_PER_PAGE = 10;

const DEFAULT_PROFESSION_GROUP_ID = '';

export {
  DEFAULT_PAGE,
  DEFAULT_LIMIT_PER_PAGE,
  DEFAULT_COURSE_COUNT,
  DEFAULT_PROFESSION_GROUP_ID,
  DEFAULT_AVGS_FILTER,
};
